import { Heading } from '@uhg-harmony/react';
import { SafeHtml } from '@/utils/SafeHtml';
import imgDME from '@/assets/images/dol-dme.png';
import styles from './DMESection.module.css';

interface DMESectionProps {
  heading: string;
  ancillaryNote: string;
  ancillaryPhone: string;
}

export function DMESection({ heading, ancillaryNote, ancillaryPhone }: DMESectionProps) {
  return (
    <section className={styles.section} tabIndex={0} aria-label="Durable Medical Equipment Section">
      <Heading level="h2" className={styles.heading}>
        {heading}
      </Heading>
      <div className={styles.body}>
        <div className={styles.iconCol} tabIndex={0} aria-label="Durable Medical Equipment Icon">
          <img
            src={imgDME}
            alt="Durable Medical Equipment"
            className={styles.icon}
          />
          {ancillaryPhone && <SafeHtml html={ancillaryPhone} className={styles.phone} />}
        </div>
        <div className={styles.textCol}>
          <SafeHtml html={ancillaryNote} />
        </div>
      </div>
    </section>
  );
}
